import React from 'react';
import PageLayout from '../../layout/PageLayout';
import NmckMedicalDevicesCalculation from '../../layout/NmckGroup/NmckMedicalDevicesCalculation';

const NmckMedicalDevicesCalculationPage: React.FC = () => (
  <PageLayout>
    <NmckMedicalDevicesCalculation />
  </PageLayout>
);

export default NmckMedicalDevicesCalculationPage;
